import { useTranslation } from 'react-i18next';
import CategoryGrid from './CategoryGrid';

export default function CategoriesSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-foreground-900 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <CategoryGrid
          startIndex={0}
          count={4}
          title={t('categories.title')}
        />
        <CategoryGrid
          startIndex={4}
          count={4}
          title={t('categories.title')}
        />
        <CategoryGrid
          startIndex={8}
          count={4}
          title={t('categories.title')}
        />
        <CategoryGrid
          startIndex={12}
          count={2}
          title={t('categories.title')}
        />
      </div>
    </section>
  );
}